<dx-popup
  [visible]="visibleSig()"
  [container]="resolvePopupTarget()"
  [position]="{ my: 'center', at: 'center', of: resolvePopupTarget() }"
  [showTitle]="false"
  [showCloseButton]="false"
  [hideOnOutsideClick]="true"
  [dragEnabled]="false"
  [resizeEnabled]="false"
  [shading]="true"
  [shadingColor]="'rgba(2, 6, 23, 0.38)'"
  [width]="'min(320px, calc(100% - 32px))'"
  [height]="'auto'"
  [wrapperAttr]="{ class: 'vimeo-video__share-popup-wrapper' }"
  (onHiding)="handleHiding()"
>
  <div
    *dxTemplate="let data of 'content'"
    class="vimeo-video__share-panel"
    role="dialog"
    [attr.aria-label]="isPrivateVideoSig() ? 'Private video' : 'Share video'"
  >
    <div class="vimeo-video__share-panel-header">
      <div class="vimeo-video__share-panel-title">{{ isPrivateVideoSig() ? 'Private Video' : 'Share Link' }}</div>

      <button
        type="button"
        class="vimeo-video__share-panel-close"
        aria-label="Close share panel"
        (click)="handleClose()"
      >
        <span class="dx-icon dx-icon-close" aria-hidden="true"></span>
      </button>
    </div>

    <div *ngIf="isPrivateVideoSig(); else shareContent" class="vimeo-video__private-message">
      <div class="vimeo-video__private-message-icon" aria-hidden="true">
        <span class="dx-icon dx-icon-lock"></span>
      </div>

      <p class="vimeo-video__private-message-text">{{ privateVideoMessageSig() }}</p>
    </div>

    <ng-template #shareContent>
      <div class="vimeo-video__share-link">
        <input class="vimeo-video__share-link-input" [value]="shareLinkSig()" readonly aria-label="Share link" />

        <button
          type="button"
          class="vimeo-video__share-link-copy"
          [attr.aria-label]="copyButtonTextSig() === 'Copied' ? 'Link copied' : 'Copy share link'"
          [class.vimeo-video__share-link-copy--copied]="copyButtonTextSig() === 'Copied'"
          (click)="handleCopy()"
        >
          <span class="dx-icon dx-icon-agi-copy" aria-hidden="true"></span>
        </button>
      </div>

      <div class="vimeo-video__share-socials">
        <button
          *ngFor="let action of socialShareActions"
          type="button"
          class="vimeo-video__share-social-button"
          [attr.aria-label]="action.label"
          [title]="action.label"
          (click)="shareTo(action.key)"
        >
          <span class="dx-icon vimeo-video__share-social-icon" [class]="action.iconClass" aria-hidden="true"></span>
        </button>
      </div>
    </ng-template>
  </div>
</dx-popup>